import React from 'react';
import './animate7.less';

const Animate7: React.FC = () => {
    return (
        <div className="c-animate7">
            <video
                autoPlay={true}
                loop={true}
                src="https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/imgs/saas-editor/treeShadow.webm"
            />
        </div>
    );
};

export default Animate7;
